// extracted by mini-css-extract-plugin
export default {"root":"AnswerCardDrawer_root__BCuVJ"};